import { render } from "./SignInPayment.vue?vue&type=template&id=60f2e8e0&scoped=true"
import script from "./SignInPayment.vue?vue&type=script&lang=js"
export * from "./SignInPayment.vue?vue&type=script&lang=js"

import "./SignInPayment.vue?vue&type=style&index=0&id=60f2e8e0&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f2e8e0"]])

export default __exports__